import {
  TEMPLATES_DATA_INITIALIZE,
  TEMPLATES_DOMAIN_DATA_INITIALIZE,
} from '@app/store/actionTypes';
import BlobFile from '@app/store/documents/BlobFile';
import SampleFile from '@app/store/documents/SampleFile';
import UploadFile from '@app/store/documents/UploadFile';

export interface TemplateFileUploadRequestPayload {
  file: File | UploadFile | SampleFile | BlobFile;
  purpose: 'templateCreate' | 'templateFileChange';
}

export function initializeTemplatesData() {
  return {
    type: TEMPLATES_DATA_INITIALIZE,
  };
}

export function initializeTemplatesDomainData() {
  return {
    type: TEMPLATES_DOMAIN_DATA_INITIALIZE,
  };
}

export type TemplatesAction =
  | ReturnType<typeof initializeTemplatesData>
  | ReturnType<typeof initializeTemplatesDomainData>;
